import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    memberLoggedIn: false,
    sponsorLoggedIn: false,
    adminLoggedIn: false,
    user: null,
    dark: false
  },
  mutations: {
    loginUser(state, user) {
      Vue.set(state, "user", user);
      Vue.set(state, "memberLoggedIn", true);
    },
    loginSponsor(state, user) {
      Vue.set(state, "user", user);
      Vue.set(state, "sponsorLoggedIn", true);
    },
    loginAdmin(state, user) {
      Vue.set(state, "user", user);
      Vue.set(state, "adminLoggedIn", true);
    },
    logout(state) {
      Vue.set(state, "user", null);
      Vue.set(state, "memberLoggedIn", false);
      Vue.set(state, "sponsorLoggedIn", false);
      Vue.set(state, "adminLoggedIn", false);
    }
  },
  getters: {
    user: state => state.user
  },
  actions: {}
});
